import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import * as yup from "yup";

export const NovaSenhaSchema = yup.object().shape({
  senha: yup
    .string()
    .required(mensagemDeErroPadrao("Senha"))
    .min(4, "Sua senha deve ter no mínimo 4 caracteres")
    .max(100, "Sua senha deve ter no máximo 100 caracteres")
    .oneOf(
      [yup.ref("confirmarSenha")],
      'O Campo "Confirme a nova senha" e "Senha" devem ser iguais'
    ),

  confirmarSenha: yup
    .string()
    .required(mensagemDeErroPadrao("Confirme a nova senha"))
    .min(4, "Sua senha deve ter no mínimo 4 caracteres")
    .max(100, "Sua senha deve ter no máximo 100 caracteres")
    .oneOf([yup.ref("senha")], 'O Campo "Senha" e "Confirme a nova senha" devem ser iguais'),
});
